import React from "react";
import { Tag, Tooltip } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";

const getScoreColor = (score) => {
  const colors = {
    5: 'green',      // отлично
    4: 'lime',       // хорошо
    3: 'gold',       // удовлетворительно
    2: 'orange',     // плохо
    1: 'red'         // очень плохо
  };
  return colors[score] || 'default';
};

const truncateText = (text, maxLength = 200) => {
  if (!text) return '—';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const getTableColumns = (onViewDetails) => {
  return [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
      width: 150,
      sorter: (a, b) => moment(a.rawDate).unix() - moment(b.rawDate).unix(),
      defaultSortOrder: 'descend',
    },
    {
      title: "Клиент",
      dataIndex: "clientName",
      key: "clientName",
      width: 200,
      ellipsis: true,
      render: (text, record) => (
        <Link to={`/client/${record.clientId}`}>{text}</Link>
      ),
    },
    {
      title: "Оценка",
      dataIndex: "score",
      key: "score",
      width: 100,
      align: "center",
      render: (score) => (
        <Tag 
          color={getScoreColor(score)} 
          style={{ fontSize: 16, padding: '5px 15px', fontWeight: 'bold' }}
        >
          {score}
        </Tag>
      ),
      sorter: (a, b) => a.rawScore - b.rawScore,
      filters: [
        { text: '5 (Отлично)', value: 5 },
        { text: '4 (Хорошо)', value: 4 },
        { text: '3 (Нормально)', value: 3 },
        { text: '2 (Плохо)', value: 2 },
        { text: '1 (Очень плохо)', value: 1 },
      ],
      onFilter: (value, record) => record.rawScore === value,
    },
    {
      title: "Комментарий",
      dataIndex: "comment",
      key: "comment",
      render: (comment) => {
        const text = truncateText(comment);
        if (!comment) return text;
        
        return (
          <Tooltip title={comment} placement="topLeft">
            <span style={{ whiteSpace: 'pre-wrap', cursor: 'help' }}>{text}</span>
          </Tooltip>
        );
      },
    },
  ];
};

export const getTableDataSource = (npsData = []) => {
  if (!Array.isArray(npsData)) {
    return [];
  }

  return npsData.map((item, index) => {
    const clientName = item.client?.name || 
                       item.client?.fullNameDirector || 
                       'Не указано';
    
    return {
      key: item._id || index,
      date: moment(item.date).format('DD.MM.YYYY HH:mm'),
      rawDate: item.date,
      clientId: item.client?._id,
      clientName: clientName,
      score: item.score,
      rawScore: item.score,
      comment: item.comment || '',
      orderId: item.order?._id,
      npsSessionId: item.npsSessionId,
      chatId: item.chatId,
      rawData: item,
    };
  });
};
